export interface LoanSummary {
  totalLoanBalance: number;
  totalNextDueAmount: number;
  totalInterestDue: number;
  totalPrincipalDue: number;
  totalEscrowDue: number;
}

export class LoanSummary implements LoanSummary {
  constructor(init?: LoanSummary) {
    Object.assign(this, init);
  }
}